import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _37ec5485 = () => interopDefault(import('../src/pages/lounge-portal/checkout.vue' /* webpackChunkName: "pages/lounge-portal/checkout" */))
const _eeb05f6e = () => interopDefault(import('../src/pages/lounge-portal/receipt.vue' /* webpackChunkName: "pages/lounge-portal/receipt" */))
const _434facb2 = () => interopDefault(import('../src/pages/lounge-portal/search.vue' /* webpackChunkName: "pages/lounge-portal/search" */))
const _2ac358c7 = () => interopDefault(import('../src/pages/lounge-portal/travel-extras.vue' /* webpackChunkName: "pages/lounge-portal/travel-extras" */))
const _ef1b74da = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/lounge-portal/checkout",
    component: _37ec5485,
    name: "lounge-portal-checkout"
  }, {
    path: "/lounge-portal/receipt",
    component: _eeb05f6e,
    name: "lounge-portal-receipt"
  }, {
    path: "/lounge-portal/search",
    component: _434facb2,
    name: "lounge-portal-search"
  }, {
    path: "/lounge-portal/travel-extras",
    component: _2ac358c7,
    name: "lounge-portal-travel-extras"
  }, {
    path: "/",
    component: _ef1b74da,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
